// extracted by mini-css-extract-plugin
export default {"upload":"upload-t8xad","cameraIcon":"cameraIcon-yBnob","image":"image-p7tOZ","trashIcon":"trashIcon-MmGS0"};